module.exports = __webpack_public_path__ + "static/media/jessie.deaeb115.png";